import { useMemo } from 'react'
import { useTimeline } from '../../context/useTimeline'
import { useNavigation } from '../../context/useNavigation'

/**
 * Returns the active goal ID if it represents a readable goal in the current workspace,
 * or null if unlinked, path-only, or not a goal.
 */
export function useLinkedGoalPrefill(): string | null {
  const { elements, pathOnlyElementIds } = useTimeline()
  const { activeGoalId } = useNavigation()

  return useMemo(() => {
    if (!activeGoalId || !elements) return null
    const isReadable = elements.some(
      (el) => el.type === 'GOAL' && el.id === activeGoalId && !pathOnlyElementIds?.has(el.id),
    )
    return isReadable ? activeGoalId : null
  }, [activeGoalId, elements, pathOnlyElementIds])
}
